import HtmlTemplateProduct from './components/HtmlTemplateProduct'
import HtmlTemplateLoader from './components/HtmlTemplateLoader'

export default {
    install(Vue, option) {
        Vue.component('HtmlTemplateProduct', HtmlTemplateProduct);
        Vue.component('HtmlTemplateLoader', HtmlTemplateLoader);
    }
};